import { render, staticRenderFns } from "./slaccountbank.vue?vue&type=template&id=3b00a64c&"
import script from "./slaccountbank.vue?vue&type=script&lang=js&"
export * from "./slaccountbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports